import moment from '@tw/moment-cached/module/timezone';
import { createSelector } from '../reselect';
import {
  total,
  simpleChart,
  dayCp,
  average,
  simpleChart4,
  simpleChart2,
  safeDivide,
  simpleChartWithManipulateFunction,
  getViewThrough,
  simpleChart3,
  getNewStatsService,
} from '../generalUtils';

const getNewStats = getNewStatsService('facebook-ads');

const chartFacebookCp = (stats, prop) => {
  var chart = [];
  var lastYearDays;
  var firstStatDay;
  var isOneDay = stats.length == 1;
  if (stats[0]) {
    lastYearDays = moment(stats[0].start).endOf('year').dayOfYear();
    firstStatDay = moment(stats[0].start).dayOfYear();
  }
  stats.forEach((day) => {
    if (isOneDay) {
      chart = Array.from({ length: 24 }).map((_, i) => ({
        x: Number(i),
        y: 0,
      }));
      Object.entries(day.hours).forEach(([key, hour]) => {
        if (hour[prop]) {
          chart.find((i) => i.x == Number(key)).y = Number(hour[prop]);
        }
      });
    } else {
      let x = moment(day.start).dayOfYear();
      if (x < firstStatDay) x += lastYearDays;
      var dayTotal = 0;
      Object.values(day.hours).forEach((hour) => {
        if (hour[prop]) {
          dayTotal += Number(hour[prop]);
        }
      });

      chart.push({ x, y: dayTotal });
    }
  });

  return chart;
};

// spend
const totalFacebookInsights = createSelector([getNewStatsService('facebook-ads')], (stats) => {
  return total(stats, 'spend');
});

const chartFacebookInsights = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

// purchases

//old versions for old infra
const totalFacebookPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const facebookPurchasesNew = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const facebookPurchase = createSelector([getNewStats], (stats) => {
  if (!stats.length) return 0;
  return total(stats, 'purchases');
});
//old versions for old infra - until here

const facebookMetaPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'metaPurchases');
});

const facebookMetaPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'metaPurchases');
});

const facebookWebPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const facebookWebPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'purchases');
});

const facebookPurchases = createSelector(
  [facebookWebPurchases, facebookMetaPurchases],
  (web, meta) => {
    return web + meta;
  }
);
const facebookPurchasesChart = createSelector(
  [facebookWebPurchasesChart, facebookMetaPurchasesChart],
  (web, meta) => {
    return simpleChart3(web, meta);
  }
);

//outboundClicks
const facebookOutboundClicks = createSelector([getNewStats], (stats) => {
  return total(stats, 'outboundClicks');
});

const chartFacebookOutboundClick = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'outboundClicks');
});

//Impressions
const facebookImpressions = createSelector([getNewStats], (stats) => {
  return total(stats, 'impressions');
});

const facebookImpressionsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'impressions');
});

// cv

const facebookWebConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const facebookWebConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const facebookMetaConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'metaConversionValue');
});

const facebookMetaConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'metaConversionValue');
});

const facebookPurchaseConversionValue = createSelector(
  [facebookWebConversionValue, facebookMetaConversionValue],
  (web, meta) => {
    return meta + web;
  }
);

const facebookPurchaseConversionValueChart = createSelector(
  [facebookWebConversionValueChart, facebookMetaConversionValueChart],
  (web, meta) => {
    return simpleChart3(web, meta);
  }
);

// one day cv
const facebookDayViewPurchaseConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'oneDayViewConversionValue');
});

//clicks
const facebookClicks = createSelector([facebookImpressions, getNewStats], (impressions, stats) => {
  return total(stats, 'clicks');
});

const facebookClicksChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

//video
const facebookTotalVideoPlays = createSelector([getNewStats], (stats) => {
  return total(stats, 'totalVideoView');
});

const facebookThreeSecondVideoView = createSelector([getNewStats], (stats) => {
  return total(stats, 'threeSecondVideoView');
});

// cpc
const averageFacebookCpc = createSelector(
  [facebookClicks, totalFacebookInsights],
  (clicks, spend) => {
    return safeDivide(spend, clicks);
  }
);

const chartFacebookCpc = createSelector(
  [facebookClicksChart, chartFacebookInsights],
  (clicks, spend) => {
    return simpleChart2(spend, clicks);
  }
);

// cpoc
const facebookCostPerOutboundClick = createSelector(
  [facebookOutboundClicks, totalFacebookInsights],
  (outboundClicks, spend) => {
    return safeDivide(spend, outboundClicks);
  }
);

const chartFacebookCostPerOutboundClick = createSelector(
  [chartFacebookOutboundClick, chartFacebookInsights],
  (outboundClicks, spend) => {
    return simpleChart2(spend, outboundClicks);
  }
);

//VT
const facebookViewThrough = createSelector([getNewStats], (stats) => {
  return total(stats, 'twViewThrough');
});

const facebookViewThroughChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'twViewThrough');
});

const facebookViewThroughRoas = createSelector(
  [facebookViewThrough, totalFacebookInsights],
  (viewCV, spend) => {
    return safeDivide(viewCV, spend);
  }
);

const facebookViewThroughRoasChart = createSelector(
  [facebookViewThroughChart, chartFacebookInsights],
  (viewCV, spend) => {
    return simpleChart2(viewCV, spend);
  }
);

//TODO
const facebookViewThroughCpa = createSelector(
  [facebookViewThrough, totalFacebookInsights],
  (viewCV, spend) => {
    return 0;
  }
);

const facebookViewThroughCpaChart = createSelector(
  [facebookViewThroughChart, chartFacebookInsights],
  (viewCV, spend) => {
    return [];
  }
);

// ctr
const facebookCtr = createSelector([facebookClicks, facebookImpressions], (clicks, impressions) => {
  return safeDivide(clicks, impressions) * 100;
});

// oc ctr
const facebookOutboundClicksCtr = createSelector(
  [facebookOutboundClicks, facebookImpressions, getNewStats],
  (outboundClicks, impressions, stats) => {
    if (!stats.length) return 0;
    return safeDivide(outboundClicks, impressions) * 100;
  }
);

// cpm
const averageFacebookCpm = createSelector(
  [facebookImpressions, totalFacebookInsights],
  (impressions, spend) => {
    return safeDivide(spend, impressions / 1000);
  }
);

const chartFacebookCpm = createSelector(
  [facebookImpressionsChart, chartFacebookInsights],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const chartFacebookCtr = createSelector(
  [facebookClicksChart, facebookImpressionsChart, getNewStats],
  (clicks, impressions) => {
    return simpleChart2(clicks, impressions, { chart1yMultiplier: 100 });
  }
);

const averageFacebookPurchaseRoas = createSelector(
  [facebookPurchaseConversionValue, totalFacebookInsights],
  (conversionValue, spend) => {
    return safeDivide(conversionValue, spend);
  }
);

const averageFacebookDayViewPurchaseRoas = createSelector(
  [facebookDayViewPurchaseConversionValue, totalFacebookInsights],
  (conversionValue, spend) => {
    return safeDivide(conversionValue, spend);
  }
);

const chartFacebookPurchaseRoas = createSelector(
  [facebookPurchaseConversionValueChart, chartFacebookInsights],
  (conversionValue, spend) => {
    return simpleChart2(conversionValue, spend);
  }
);

const facebookConversionValue = createSelector([facebookPurchaseConversionValue], (cv) => {
  return cv;
});

const facebookDayViewConversionValue = createSelector(
  [facebookDayViewPurchaseConversionValue],
  (cv) => {
    return cv;
  }
);

const facebookConversionValueChart = createSelector(
  [chartFacebookInsights, chartFacebookPurchaseRoas],
  (chartFacebookInsights, chartFacebookPurchaseRoas) =>
    simpleChart4(chartFacebookInsights, chartFacebookPurchaseRoas)
);

const facebook3sVideoViewPercentage = createSelector(
  [facebookTotalVideoPlays, facebookThreeSecondVideoView],
  (facebookTotalVideoPlays, facebookThreeSecondVideoView) =>
    !facebookTotalVideoPlays ? 0 : (facebookThreeSecondVideoView / facebookTotalVideoPlays) * 100
);

const facebookCpa = createSelector(
  [totalFacebookInsights, facebookPurchases],
  (totalFacebookInsights, facebookPurchases) =>
    !facebookPurchases ? 0 : totalFacebookInsights / facebookPurchases
);

const facebookCpaChart = createSelector(
  [chartFacebookInsights, facebookPurchasesChart],
  (chartFacebookInsights, facebookPurchasesChart) =>
    simpleChart2(chartFacebookInsights, facebookPurchasesChart)
);

const facebookRevenuePerClick = createSelector(
  [facebookConversionValue, facebookCostPerOutboundClick, totalFacebookInsights],
  (facebookConversionValue, facebookCostPerOutboundClick, totalFacebookInsights) =>
    !totalFacebookInsights
      ? 0
      : !facebookCostPerOutboundClick
      ? 0
      : facebookConversionValue / (totalFacebookInsights / facebookCostPerOutboundClick)
);

const facebookRevenuePerClickChart = createSelector(
  [facebookConversionValueChart, chartFacebookCostPerOutboundClick, chartFacebookInsights],
  (facebookConversionValueChart, chartFacebookCostPerOutboundClick, chartFacebookInsights) => {
    var tmp = simpleChart2(chartFacebookInsights, chartFacebookCostPerOutboundClick);
    return simpleChart2(facebookConversionValueChart, tmp);
  }
);

const PROPS_TO_SELECTORS = {};
export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    chartFacebookCp,
    totalFacebookInsights,
    chartFacebookInsights,
    totalFacebookPurchases,
    averageFacebookCpc,
    facebookCostPerOutboundClick,
    facebookCtr,
    facebookViewThrough,
    facebookViewThroughChart,
    facebookViewThroughRoas,
    facebookViewThroughRoasChart,
    facebookViewThroughCpa,
    facebookViewThroughCpaChart,
    facebookOutboundClicksCtr,
    facebookOutboundClicks,
    facebookPurchase,
    facebookMetaPurchases,
    facebookWebPurchases,
    averageFacebookCpm,
    chartFacebookCpc,
    chartFacebookCostPerOutboundClick,
    chartFacebookCpm,
    chartFacebookCtr,
    facebookPurchaseConversionValue,
    facebookWebConversionValue,
    facebookMetaConversionValue,
    facebookWebConversionValueChart,
    facebookMetaConversionValueChart,
    facebookDayViewPurchaseConversionValue,
    facebookImpressions,
    facebookClicks,
    averageFacebookPurchaseRoas,
    averageFacebookDayViewPurchaseRoas,
    chartFacebookPurchaseRoas,
    facebookConversionValue,
    facebookDayViewConversionValue,
    facebookConversionValueChart,
    chartFacebookOutboundClick,
    facebookPurchases,
    facebookPurchasesNew,
    facebookTotalVideoPlays,
    facebookThreeSecondVideoView,
    facebook3sVideoViewPercentage,
    facebookPurchasesChart,
    facebookWebPurchasesChart,
    facebookMetaPurchasesChart,
    facebookCpa,
    facebookCpaChart,
    facebookRevenuePerClick,
    facebookRevenuePerClickChart,
    // aliases
    fb_ads_spend: totalFacebookInsights,
    fb_ads_purchase_roas: averageFacebookPurchaseRoas,
  },
};
